import { createContext, useContext } from 'react';

import type {
  InternetSpeedResult,
  NetworkQuality,
  NetworkSample,
  SpeedTestResult,
} from '@/lib/network-speed';

export type NetworkTestStep = 'idle' | 'latency' | 'download' | 'upload' | 'internet';

export interface NetworkMonitorState {
  online: boolean;
  quality: NetworkQuality;
  history: NetworkSample[];
  /** Last test result: connection to our backend server. */
  lastFullTest: SpeedTestResult | null;
  /** Last test result: real Internet speed (Cloudflare engine). */
  lastInternetTest: InternetSpeedResult | null;
  isFullTestRunning: boolean;
  fullTestProgress: number;
  testStep: NetworkTestStep;
  testStepLabel: string;
  runManualTest: () => Promise<void>;
}

export const NetworkMonitorContext = createContext<NetworkMonitorState | null>(null);

export function useNetworkMonitor(): NetworkMonitorState {
  const ctx = useContext(NetworkMonitorContext);
  if (!ctx) throw new Error('useNetworkMonitor must be used within NetworkMonitorProvider');
  return ctx;
}
